import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';

import StyledJadeSoftTeam from './styles';
import { useNavigate } from 'react-router';

import { useTranslation } from 'react-i18next';

const SelfService = () => {
  const theme = useTheme();
  const [isTop, setIsTop] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const label = t('selfservice-content-one');
  const labelMobile = t('selfservice-content-one');
  const label2 = `JADE SOFT 플랫폼의 고객 변경 사항은 언제나 빠르고 쉽게 적용됩니다.`;
  const label3 = t('selfservice-content-two');
  const GameIcon = [
    {
      id: 1,
      title: '기술 세부사항',
      subTitle: '',
      content: [
        {
          id: 1,
          title: 'Front-end',
          color: '#FFCD58',
          content:
            'AngularJS 기반으로 구축된 프런트 엔드 제품을 사용해보세요. AngularJS는 IT 전문가가 자바스크립트로 프런트엔드를 작성할 수 있도록 해주는 Google의 제품입니다.',
        },
        {
          id: 2,
          title: 'Design',
          color: '#40C651',
          content: '고객님께서 직접 디자인을 만들어서 엔진에 적용해 보세요.',
        },
        {
          id: 3,
          title: 'Functionalities',
          color: '#D46094',
          content:
            'White Label 및 Turnkey 솔루션에 사용할 수 있는 모든 기능은 Self-Service 솔루션에도 사용할 수 있습니다. 개발자 팀이 있는 경우 이를 통해 개발 프로세스를 용이하게 하고 필요에 맞는 카지노를 구축하는 데 도움이 됩니다.',
        },
      ],
    },
    {
      id: 2,
      title: '고객님의 IT 팀',
      subTitle: '카지노를 개발하는 데 필요한 권장 인원은 3명입니다.',
      content: [
        {
          id: 1,
          title: '웹 디자이너',
          color: '#FF3F3B',
          content: '',
        },
        {
          id: 2,
          title: 'HTML/CSS로 모형을 만드는 UI 프런트 엔드 엔지니어',
          color: '#4DC5CC',
          content: '',
        },
        {
          id: 3,
          title: 'Javascript에 대한 지식을 갖춘 프런트 엔드 웹 개발자',
          color: '#DADADA',
          content: '',
        },
      ],
    },
  ];

  // const HourIcon = [
  //   {
  //     id: 1,
  //     title: '고객',
  //     content: ['디자인', 'Front-end HTML coding', '소규모 IT 전문가 팀'],
  //     image: <B2BIcon />,
  //   },
  //   {
  //     id: 2,
  //     title: 'JADE SOFT',
  //     content: [
  //       '자사 기술 문서',
  //       '스크립트 세트',
  //       'Front-end 디자인 자문',
  //       '카지노 개발의 모든 단계에서 지원',
  //       '엔진',
  //       '테스트 플랫폼',
  //       '새로운 기능을 갖춘 시스템에 대한 무료 업데이트',
  //       '백 오피스',
  //     ],
  //     image: <SelfServiceJadeSoftIcon />,
  //   },
  // ];

  const grayPanel = [
    {
      id: 1,
      content: [
        t('selfservice-col-one-one'),
        t('selfservice-col-one-two'),
        t('selfservice-col-one-three'),
        t('selfservice-col-one-four')
      ],
    },
    {
      id: 2,
      content: [
        t('selfservice-col-two-one'),
        t('selfservice-col-two-two'),
        t('selfservice-col-two-three'),
      ],
    },
    {
      id: 3,
      content: [
        t('selfservice-col-three-one'),
        t('selfservice-col-three-two'),
        t('selfservice-col-three-three'),
        t('selfservice-col-three-four'),
      ],
    },
  ];

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        const position = window.scrollY;
        if (position === 0) {
          setIsTop(false);
        } else {
          setIsTop(true);
        }
      };

      window.addEventListener('scroll', handleScroll);

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isTop]);

  return (
    <StyledJadeSoftTeam>
      <Box className="homeBg">
        {/* <img className="bgImage" src={JadeSoftTeamImage} /> */}
        <Box
          sx={{
            textAlign: { xs: 'center', md: 'center' },
            zIndex: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '60%',
            // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
            zIndex: 1,
            // padding: '9% 25% 8% 25%',
            [theme.breakpoints.down('lg')]: {
              // padding: '9% 5% 8% 5%',
              height: '57%',
            },
          }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'center' },
              zIndex: 1,
              position: 'relative',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
              zIndex: 1,
              padding: '5% 0% 10% 0%',
              // backgroundColor: isTop ? '#02b201' : '#acfa4f',
            }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: '64px',
                fontWeight: 900,
                lineHeight: '76.38px',
                color: '#000000',
                [theme.breakpoints.down('lg')]: {
                  mt: 5,
                  fontSize: '55px',
                  lineHeight: '65.63px',
                },
              }}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                  },
                }}
              // viewport={{ once: true }}
              >
                {t('selfservice-title')}
              </motion.div>
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                // padding: '0 20%',
                [theme.breakpoints.down('lg')]: {
                  padding: '0',
                },
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  wordWrap: 'break-word',
                  fontWeight: 600,
                  fontSize: '20px',
                  mt: 3,
                  lineHeight: '23.87px',
                  color: '#121421',
                  [theme.breakpoints.down('lg')]: {
                    mt: 1,
                    fontSize: '18px',
                    lineHeight: '23.87px',
                    display: 'none',
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: 0.8,
                    },
                  }}
                // viewport={{ once: true }}
                >
                  <p>{parse(label)}</p>
                </motion.div>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  wordWrap: 'break-word',
                  fontWeight: 600,
                  fontSize: '20px',
                  mt: 3,
                  lineHeight: '29px',
                  color: '#121421',
                  display: 'none',
                  [theme.breakpoints.down('lg')]: {
                    mt: 1,
                    fontSize: '18px',
                    lineHeight: '23.4px',
                    display: 'flex',
                    padding: '0px 10px',
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: 0.8,
                    },
                  }}
                // viewport={{ once: true }}
                >
                  <p>{parse(labelMobile)}</p>
                </motion.div>
              </Typography>
            </Box>
            <Box justifyContent={'center'} display={'flex'}>
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 2, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              >
                <Button
                  variant="contained"
                  onClick={() => navigate('/contact')}
                  sx={{
                    color: '#FFFFFF',
                    backgroundColor: '#5B3EDE',
                    borderColor: '#00AA2F',
                    borderRadius: '4px',
                    width: '189px',
                    height: '49px',
                    // marginRight: '30px',
                    marginTop: 5,
                    marginBottom: 10,
                    fontSize: '16px',
                    fontWeight: 400,
                    [theme.breakpoints.down('lg')]: {
                      width: '100%',
                      justifyContent: 'center',
                      display: 'none',
                    },
                  }}
                >
                  {t('selfservice-button')}
                </Button>
                <Button
                  variant="contained"
                  onClick={() => navigate('/contact')}
                  sx={{
                    color: '#FFFFFF',
                    backgroundColor: '#5B3EDE',
                    borderColor: '#00AA2F',
                    borderRadius: '4px',
                    width: '136px',
                    height: '50px',
                    // marginRight: '30px',
                    marginTop: 5,
                    marginBottom: 10,
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'none',
                    [theme.breakpoints.down('lg')]: {
                      justifyContent: 'center',
                      display: 'flex',
                      fontWeight: 800,
                      width: '100%'
                    },
                  }}
                >
                  {t('selfservice-button')}
                </Button>
              </motion.div>
            </Box>
          </Box>
          {/* <Wave
            fill={isTop ? '#acfa4f' : '#02b201'}
            paused={false}
            style={{ display: 'flex', marginTop: '-33px', height: '50px', position: 'absolute', zIndex: 999 }}
            options={{
              height: 20,
              amplitude: 20,
              speed: 0.15,
              points: 3,
            }}
          />
          <Wave
            fill={isTop ? '#acfa4f' : '#02b201'}
            paused={false}
            style={{ display: 'flex', marginTop: '-5px', height: '50px', transform: 'scaleY(-1)' }}
            options={{
              height: 10,
              amplitude: 20,
              speed: 0.25,
              points: 3,
            }}
          /> */}

          {/* <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              mt: 4,
              [theme.breakpoints.down('lg')]: {
                mt: 0,
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '509px',
                height: '108px',
                mt: 5,
                [theme.breakpoints.down('lg')]: {
                  width: '360px !important',
                  height: '76px !important',
                  mt: 0,
                },
              }}
            >
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  fontSize: '48px',
                  fontWeight: 700,
                  lineHeight: '57.28px',
                  color: '#444444',
                  [theme.breakpoints.down('lg')]: {
                    mt: 5,
                    fontSize: '40px',
                    lineHeight: '47.73px',
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                    },
                  }}
    
                >
                Key Advantage
                </motion.div>
              </Typography>
            </Box>
          </Box> */}

          {/* <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              [theme.breakpoints.down('lg')]: {
                padding: '0 20px',
              },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.8,
                wordWrap: 'break-word',
                fontWeight: 700,
                fontSize: '20px',
                mt: 3,
                lineHeight: '29px',
                color: '#000',
                [theme.breakpoints.down('lg')]: {
                  mt: 3,
                  fontSize: '18px',
                  lineHeight: '23.4px',
                  textAlign: 'center',
                  color: '#444444',
                  fontWeight: 600,
                },
              }}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              >
                {parse(label2)}
              </motion.div>
            </Typography>
          </Box> */}
        </Box>
      </Box>
      <Box className="homeContent">
        {/* <Box
          // mt={15}
          mb={13}
          // display={'flex'}
          justifyContent={'center'}
          sx={{
            maxWidth: '100%',
            maxHeight: '100%',
            color: '#000000',
            [theme.breakpoints.down('lg')]: {
              mt: 3,
              padding: '0 20px',
            },
          }}
        >
          <Grid container rowSpacing={{ xs: 0, sm: 0, md: 15, lg: 15, xl: 15 }} columnSpacing={4}>
            {HourIcon.map((item, index) => (
              <Grid item sx={{
                display: 'flex',
                justifyContent: 'center',
              }} xs={12} sm={12} md={12} lg={12} xl={6} key={index}>
                <Box
                  sx={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    width: '697.5px',
                    mt: 5,
                    justifyContent: 'center',
                  }}
                  display={'flex'}
                  key={item.id}
                >
                  <Box
                    sx={{
                      // backgroundColor: '#ffffff',
                      backgroundColor: '#F7F5F6',
                      textAlign: 'left',
                      // paddingLeft: 0,
                      // paddingRight: 0,
                      width: '697.5px',
                      height: '482.59px',
                      padding: '60px',
                      maxHeight: '100%',
                      borderRadius: '10px',
                      boxShadow: '0px 4px 4px 0px #00000040',
                      [theme.breakpoints.down('lg')]: {
                        background: '#F7F5F6',
                        padding: '50px 10px',
                        width: '100%',
                        height: '100%',
                        textAlign: 'center',
                      },
                    }}
                  >
                    <Box>{item.image}</Box>
                    <Typography
                      variant="body1"
                      sx={{
                        mt: 6,
                        // mb: 7,
                        lineHeight: '40.57px',
                        wordWrap: 'break-word',
                        fontWeight: 800,
                        fontSize: '34px',
                        color: '#444444',
                        textAlign: 'left',
                        justifyContent: 'left',
                        [theme.breakpoints.down('lg')]: {
                          mt: 2,
                          fontSize: '25px',
                          lineHeight: '29.83px',
                          textAlign: 'center',
                          justifyContent: 'center',
                        },
                      }}
                    >
                      {parse(item.title)}
                    </Typography>
                    <ul>
                      {item.content.map((text, i) => (
                        <li>
                          <Typography
                            variant="body1"
                            sx={{
                              // mt: 6,
                              // mb: 7,
                              lineHeight: '23.87px',
                              wordWrap: 'break-word',
                              fontWeight: 600,
                              fontSize: '20px',
                              color: '#000',
                              textAlign: 'left',
                              justifyContent: 'left',
                              [theme.breakpoints.down('lg')]: {
                                // mt: 2,
                                fontSize: '20px',
                                lineHeight: '26px',
                                color: '#676767',
                              },
                            }}
                          >
                            {parse(text)}
                          </Typography>
                        </li>
                      ))}
                    </ul>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box> */}
        <Box
          sx={{
            backgroundColor: '#555555',
            padding: '4% 10% 0 10%',
            [theme.breakpoints.down('lg')]: {
              padding: '4% 5% 0 5%',
            }
          }}
        >
          {/* {GameIcon.map((object, i) => (
            <>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  mb: 2,
                  lineHeight: '57.28px',
                  wordWrap: 'break-word',
                  fontWeight: 900,
                  fontSize: '48px',
                  color: '#FFFFFF',
                  textAlign: 'left',
                  [theme.breakpoints.down('lg')]: {
                    mt: 1,
                    fontSize: '40px',
                    lineHeight: '47.73px',
                    color: '#FFFFFF',
                    textAlign: 'center',
                  },
                }}
              >
                {object.title}
              </Typography>
              <Box key={i} sx={{ flex: 1, textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }}>
                <Box
                  mt={5}
                  mb={10}
                  // px={12}
                  display={'flex'}
                  justifyContent={'center'}
                  sx={{ maxWidth: '100%', maxHeight: '100%', color: '#000000' }}
                >
                  <Grid container spacing={2}>
                    {object.content.map((item, index) => (
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={4} key={index}>
                        <motion.div
                          initial={{
                            opacity: 0,
                            y: 100,
                          }}
                          whileInView={{
                            opacity: 1,
                            y: 0, // Slide in to its original position
                            transition: {
                              duration: 2, // Animation duration
                              delay: index * 1.5,
                            },
                          }}
                        // viewport={{ once: true }}
                        >
                          <Box
                            sx={{
                              maxWidth: '100%',
                              maxHeight: '100%',
                              mt: 2,
                              [theme.breakpoints.down('lg')]: {
                                mt: 2,
                                justifyContent: 'center',
                              },
                            }}
                            display={'flex'}
                            key={item.id}
                          >
                            <Box
                              sx={{
                                // backgroundColor: '#ffffff',
                                textAlign: 'left',
                                maxHeight: '100%',
                                [theme.breakpoints.down('lg')]: {
                                  textAlign: 'center',
                                  justifyContent: 'center',
                                  justifyItems: 'center',
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  width: '15.42px',
                                  height: '15.42px',
                                  backgroundColor: `${item.color}`,
                                  borderRadius: '50px',
                                  [theme.breakpoints.down('lg')]: {
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                  },
                                }}
                              ></Box>
                              <Box display={'flex'} justifyContent={'left'}>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    mt: 2,
                                    mb: 2,
                                    lineHeight: '26.67px',
                                    wordWrap: 'break-word',
                                    fontWeight: 800,
                                    fontSize: '21.3px',
                                    color: '#FFFFFF',
                                    textAlign: 'left',
                                    [theme.breakpoints.down('lg')]: {
                                      mt: 1,
                                      fontSize: '24px',
                                      lineHeight: '28.64px',
                                      color: '#FFFFFF',
                                      textAlign: 'center',
                                    },
                                  }}
                                >
                                  {item.title}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    // mb: 4,
                                    lineHeight: '20px',
                                    // wordWrap: 'break-word',
                                    fontWeight: 600,
                                    fontSize: '16px',
                                    color: '#FFFFFF',
                                    [theme.breakpoints.down('lg')]: {
                                      fontSize: '18px',
                                      fontWeight: 700,
                                      lineHeight: '23.4px',
                                      color: '#FFFFFF',
                                    },
                                  }}
                                >
                                  {parse(item.content)}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </motion.div>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </>
          ))} */}
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              mb: 2,
              lineHeight: '57.28px',
              wordWrap: 'break-word',
              fontWeight: 900,
              fontSize: '48px',
              color: '#FFFFFF',
              textAlign: 'left',
              [theme.breakpoints.down('lg')]: {
                mt: 1,
                fontSize: '40px',
                lineHeight: '47.73px',
                color: '#FFFFFF',
                textAlign: 'center',
              },
            }}
          >
            {t('selfservice-header-one')}
          </Typography>
          <Grid container rowSpacing={{ xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }} columnSpacing={4}>
            {grayPanel.map((object, i) => (
              <>

                <Grid item xs={12} sm={12} md={12} lg={4} xl={4} key={i}>
                  <motion.div
                    initial={{
                      opacity: 0,
                      y: 100,
                    }}
                    whileInView={{
                      opacity: 1,
                      y: 0, // Slide in to its original position
                      transition: {
                        duration: 2, // Animation duration
                        delay: i * 1,
                      },
                    }}
                  // viewport={{ once: true }}
                  >
                    <ul>
                      {object.content.map((item, index) => (
                        <Box
                          sx={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            mt: 2,
                            [theme.breakpoints.down('lg')]: {
                              mt: 2,
                              justifyContent: 'center',
                            },
                          }}
                          display={'flex'}
                          key={item.id}
                        >
                          <Box
                            sx={{
                              // backgroundColor: '#ffffff',
                              textAlign: 'left',
                              maxHeight: '100%',
                              fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                              fontSize: '18px',
                              lineHeight: '22.32px',
                              [theme.breakpoints.down('lg')]: {
                                fontSize: '18.7px',
                                textAlign: 'center',
                                justifyContent: 'center',
                                justifyItems: 'center',
                              },
                            }}
                          >
                            <li>{parse(t(item))}</li>
                          </Box>
                        </Box>

                      ))}
                    </ul>
                  </motion.div>
                </Grid>
              </>
            ))}
          </Grid>
          <Typography
            variant="body1"
            sx={{
              mt: 6,
              mb: 4,
              lineHeight: '57.28px',
              wordWrap: 'break-word',
              fontWeight: 900,
              fontSize: '48px',
              color: '#FFFFFF',
              textAlign: 'left',
              [theme.breakpoints.down('lg')]: {
                mt: 1,
                fontSize: '40px',
                lineHeight: '47.73px',
                color: '#FFFFFF',
                textAlign: 'center',
              },
            }}
          >
            {t('selfservice-header-two')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              mb: 12,
              lineHeight: '23.87px',
              wordWrap: 'break-word',
              fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
              fontSize: '20px',
              color: '#FFFFFF',
              textAlign: 'left',
              [theme.breakpoints.down('lg')]: {
                mt: 1,
                mb: 5,
                fontSize: '20px',
                lineHeight: '23.87px',
                color: '#FFFFFF',
                textAlign: 'center',
              },
            }}
          >
            {parse(label3)}
          </Typography>
        </Box>
      </Box>
    </StyledJadeSoftTeam>
  );
};

export default SelfService;
